import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M6 9v1a3 3 0 0 0 3 3h1","key":"svg-0"}],["path",{"d":"M18 8v5a3 3 0 0 1 -3 3h-1","key":"svg-1"}],["path",{"d":"M10 21v-16a2 2 0 1 1 4 0v16","key":"svg-2"}],["path",{"d":"M7 21h10","key":"svg-3"}]]

const IconCactus = createReactComponent('outline', 'cactus', 'Cactus', __iconNode);

export default IconCactus;